import create from "zustand";
import { persist } from "zustand/middleware";
import { User } from "./typings/user";

interface AuthStore {
  auth: User;
  isLogged: boolean;
  reset: () => void;
  update: (auth: User, merge?: boolean) => void;
  updateIsLogged: () => void;
}

export const useCurrentAuth = create<AuthStore>(
  persist(
    (set) => ({
      auth: {} as User,
      isLogged: false as boolean,
      updateIsLogged: () => {
        set((state) => ({ ...state, isLogged: true as boolean }));
      },
      update: (auth: User, merge?: boolean) => {
        set((state) => ({ ...state, auth: merge ? {...state.auth, ...auth} : auth, isLogged: true as boolean }));
      },
      reset: () => {
        set((state) => ({
          ...state,
          auth: {} as User,
          isLogged: false as boolean,
        }));
      },
    }),
    {
      name: "@administradora-digital-user",
      getStorage: () => localStorage,
    }
  )
);
